module.exports = __webpack_public_path__ + "img/yue.815233a8.png";